import { Avatar, Box, Button, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import appcolors from "../../constants/Colors";

const DetailHeader = ({ headerData, handleViewLicenseImage }) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={3}
      alignItems={{ xs: "flex-start", md: "center" }}
      mb={3}
      p={2}
      sx={{
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
      }}
    >
      <Avatar
        src={headerData?.image}
        sx={{
          height: { xs: 100, md: 120 },
          width: { xs: 100, md: 120 },
          borderRadius: 2,
          border: "2px solid #e0e0e0",
        }}
      />
      <Stack flex={1} spacing={1}>
        <Typography
          variant="h5"
          fontWeight={600}
          textTransform="capitalize"
          lineHeight={"normal"}
        >
          {headerData?.title}
        </Typography>

        {headerData?.licenseImage && (
          <Box sx={{ mt: 1 }}>
            <Button
              variant="outlined"
              onClick={handleViewLicenseImage}
              sx={{
                width: "fit-content",
                height: 36,
                fontSize: "0.875rem",
                textTransform: "capitalize",
                borderColor: appcolors.primary,
                color: appcolors.primary,
                "&:hover": {
                  borderColor: appcolors.primary,
                  backgroundColor: "rgba(121, 34, 216, 0.08)",
                },
              }}
            >
              {`${t("view")} ${t("licenseImage")}`}
            </Button>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

export default DetailHeader;